// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trend-preview-module__container--328K_{min-height:210px;padding-bottom:45px;margin-bottom:40px;border-bottom:1px solid #e2e2e2}.trend-preview-module__image--3DCnp{display:block;position:relative;width:100%;margin-bottom:10px}.trend-preview-module__description--1vOuQ{color:#212121}.trend-preview-module__caption--3Yi9Z{color:#757575}.trend-preview-module__figure--Sp2Qn{margin-bottom:20px}", ""]);
// Exports
exports.locals = {
	"container": "trend-preview-module__container--328K_",
	"image": "trend-preview-module__image--3DCnp",
	"description": "trend-preview-module__description--1vOuQ",
	"caption": "trend-preview-module__caption--3Yi9Z",
	"figure": "trend-preview-module__figure--Sp2Qn"
};
module.exports = exports;
